/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Coaching_Invitation_ExpiresInputs */

const en_us2_coaching_invitation_expires = /** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Valid until ${i?.date}`)
};

const pt_br2_coaching_invitation_expires = /** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vale até ${i?.date}`)
};

const pt_pt2_coaching_invitation_expires = /** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vale até ${i?.date}`)
};

/** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */
const es_419_coaching_invitation_expires = en_us2_coaching_invitation_expires;

/** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */
const fr_fr2_coaching_invitation_expires = en_us2_coaching_invitation_expires;

/** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */
const de_de2_coaching_invitation_expires = en_us2_coaching_invitation_expires;

/** @type {(inputs: Coaching_Invitation_ExpiresInputs) => LocalizedString} */
const it_it2_coaching_invitation_expires = en_us2_coaching_invitation_expires;

/**
* | output |
* | --- |
* | "Valid until {date}" |
*
* @param {Coaching_Invitation_ExpiresInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_invitation_expires = /** @type {((inputs: Coaching_Invitation_ExpiresInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Invitation_ExpiresInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_invitation_expires(inputs)
	if (locale === "es-419") return es_419_coaching_invitation_expires(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_invitation_expires(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_invitation_expires(inputs)
	if (locale === "de-DE") return de_de2_coaching_invitation_expires(inputs)
	if (locale === "it-IT") return it_it2_coaching_invitation_expires(inputs)
	return en_us2_coaching_invitation_expires(inputs)
});
export { coaching_invitation_expires as "coaching.invitation_expires" }